import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import React, { useState }  from "react";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAddQuestionMutation,useGetCourseListQuery,useShowManageModuleQuery} from "../../../Services/api";

export default function Create() {
    const validationSchema = Yup.object().shape({
        exam_id: Yup.string().required("exam name fields is required"),
        coursecode: Yup.string().required("course fields is required"),
        slide_section: Yup.string().required("module fields is required"),
        status: Yup.string().required("module content type fields is required"),
        question_name: Yup.string().required("question name fields is required"),
    });
    
    let defaultValues = { name: ""};
    const notify = () => '';
    const methods = useForm({
      mode: "onTouched",
      resolver: yupResolver(validationSchema),
      defaultValues,
    });
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = methods;
    const [addQuestion,isLoading] = useAddQuestionMutation();
    const onSubmit = (values,e) => {
        
        addQuestion({ data: values })
        .unwrap()
        .then((payload) => {
            if (payload.status) {
                e.target.reset()
                toast.success(payload.message)
            } else {
                toast.error(payload.message)
            }
        })
        .catch((error) => {
            toast.error(error.data.message)
        });
        notify();
    };
    const { 
        data: getCourseList        
    } = useGetCourseListQuery({  params:''});
    const [courseCode,setCourseCode] = useState(0);
    const { 
        data: showManageModule        
    } = useShowManageModuleQuery({  params:courseCode});
    
    const findModule=(e)=>{
      setCourseCode(e.target.value);
    }
    return (
        <div className="tab-pane fade" id="bordered-justified-profile" role="tabpanel" aria-labelledby="profile-tab" >
            <section className="section">
                <div className="card">
                    <div className="card-body">
                    <h5 className="card-title">Add Question</h5>
                    <form onSubmit={handleSubmit(onSubmit)} >
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Exam Name</label>
                            <div className="col-sm-10">
                               <select  {...register("exam_id")} className="form-control" >
                                    <option value="">Select Exam Name</option>
                                    <option value="1">Quize Test - Running</option>                                           
                                    <option value="2">Final Exam - Running</option>
                                </select>
                                <span className="text-danger">{errors.exam_id?.message}</span>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Course</label>
                            <div className="col-sm-10">
                               <select  {...register("coursecode", { required: true })} className="form-control" onChange={findModule}>
                                 <option value="">Select Course</option>                                           
                                    {                            
                                    getCourseList?.data?.map((item) => {
                                        return (
                                            <option key={item.course_id} value={item.course_id}>{item.course_name}</option>                                           
                                            )
                                        })
                                    }
                                </select>
                                <span className="text-danger">{errors.coursecode?.message}</span>

                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Module Name</label>
                            <div className="col-sm-10">
                               <select  {...register("slide_section")} className="form-control" >
                                 <option value="">Select Module</option>                                           

                                {                            
                                   showManageModule?.data?.map((item) => {
                                    return (

                                         <option key={item.lesson_id} value={item.lesson_id}>{item.lesson_name}</option>                                           
                                        )
                                    })
                                }
                                </select>
                                <span className="text-danger">{errors.slide_section?.message}</span>

                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Sub module content type</label>
                            <div className="col-sm-10">
                               <select  {...register("status")} className="form-control" >
                                    <option value="">Select Module Content Type</option> 
                                    <option value="1">First Content in the same module</option>
                                    <option value="2">Second Content in the same module</option>                                           
                                    <option value="3">Third Content in the same module</option>
                                </select>
                                <span className="text-danger">{errors.status?.message}</span>

                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Question</label>
                            <div className="col-sm-10">
                                <input type="name" {...register("question_name")} className="form-control" />
                                <span className="text-danger">{errors.question_name?.message}</span>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="row">
                               <div className="col-2"></div>
                               <div className="col-10">
                                    <table>
                                        <thead>
                                            <tr>
                                            <th>Multiple Choice Option</th>
                                            <th>Correct Answer</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td style={{width:'80%'}}><input type="name" {...register("multiple_answer[0]")} className="form-control " /></td>
                                                <td style={{width:'20%'}}><input type="checkbox" {...register("correct_answer[0]")}  /></td>
                                            </tr>
                                            <tr>
                                                <td style={{width:'80%'}}><input type="name" {...register("multiple_answer[1]")} className="form-control " /></td>
                                                <td style={{width:'20%'}}><input type="checkbox" {...register("correct_answer[1]")}  /></td>
                                            </tr>
                                            <tr>
                                                <td style={{width:'80%'}}><input type="name" {...register("multiple_answer[2]")} className="form-control " /></td>
                                                <td style={{width:'20%'}}><input type="checkbox" {...register("correct_answer[2]")}  /></td>
                                            </tr>
                                            <tr>
                                                <td style={{width:'80%'}}><input type="name" {...register("multiple_answer[3]")} className="form-control " /></td>
                                                <td style={{width:'20%'}}><input type="checkbox" {...register("correct_answer[3]")}  /></td>
                                            </tr>
                                            
                                        </tbody>
                                    </table>
                               </div>

                            </div>
                        </div>
                        <div className="row mb-3">
                            <label className="col-sm-2 col-form-label"></label>
                            <div className="col-sm-10">
                              {isLoading.status !='pending' ? 
                                                
                                <button type="submit" className="btn btn-warning w-100" >Add Question</button>
                                :
                                <button  className="btn btn-warning w-100" ><div className="spinner-border text-muted"></div></button>
                                }
                            </div>
                        </div>
                    </form>
                    </div>
                </div>
            </section>
        </div>
    );
}